import ModWebParts from './containers/ModWebParts';
import React from "react";
import 'primereact/resources/primereact.min.css';
// import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.min.css';

//main container component
const App =  (props) => {
    return <ModWebParts webPartProperties={props.webPartProperties} />
}
export default App;
 

// import ModWebParts from './containers/ModWebParts';
// import React from "react";
// import ReactDOM from "react-dom";

// //main container component
// class App extends React.Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//         };
//     }
//     // componentWillMount() {
       
//     // }
    
//     render() {
//         return <ModWebParts webPartProperties={this.props.webPartProperties} />
//     }
// }
// export default App;
 